import React from 'react'
import HorizontalLinearStepper from './stepper'
import '../css/archGen.css';

export default function ArchGen() {
  return (
    <div className='container'  style={{ margin: "5ch"}}>
        <HorizontalLinearStepper/>
    </div>
  )
}
